var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4004 3.99951H1.60045C1.54348 3.99951 1.4979 4.04565 1.50007 4.10133L1.75452 10.248C1.79521 11.2264 2.61826 11.9995 3.62038 11.9995H8.37962C9.38169 11.9995 10.2053 11.2263 10.2455 10.248L10.4999 4.10133C10.5021 4.04565 10.4565 3.99951 10.3996 3.99951H10.4004Z",
    fill: "#303C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9761 1.84415C11.8922 1.51113 11.5656 1.29213 11.2192 1.29213H9.02237C8.9675 1.29213 8.92285 1.2479 8.92285 1.19355C8.92285 0.534438 8.38332 0 7.71791 0H4.28225C3.61685 0 3.07732 0.534438 3.07732 1.19355C3.07732 1.2479 3.03267 1.29213 2.9778 1.29213H0.780955C0.434539 1.29213 0.108021 1.51113 0.0241018 1.84415C-0.100157 2.33756 0.273159 2.77875 0.750825 2.77875H11.2494C11.7265 2.77875 12.0998 2.33756 11.9761 1.84415Z",
    fill: "#303C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d36a6fc771f57920d244b50a636a6150.svg";
export { ForwardRef as ReactComponent };